import React, { useState } from "react";
import { Document } from "../../__generated__/graphql";
import DocumentEditor from "./DocumentEditor";
import ListGroup from "../ListGroup";
import { StyleProp, ViewStyle } from "react-native";
import { IconName } from "../Icon";
import { ListItemProps } from "../../ui_atoms/ListItem";

export type DocumentsListProps = {
    onSelect?: (selection: Document) => void;
    documents?: (Document &
        Pick<ListItemProps, "labels"> & {
            description?: string;
            icon?: IconName;
            documentMimeType?: string;
        })[];
    onDelete?: (document: Document) => void;
    testID?: string;
    asListAction?: boolean;
    style?: StyleProp<ViewStyle>;
};

const DocumentsList: React.FC<DocumentsListProps> = ({
    onSelect,
    documents,
    onDelete,
    testID,
    style,
}) => {
    const [showDocumentEditor, setShowDocumentEditor] = useState(false);
    const [newDocument, setNewDocument] = useState<Document>();
    const [documentMimeType, setDocumentMimeType] = useState<string>();

    const closeDocumentEditor = React.useCallback(
        (document?: Document) => {
            setShowDocumentEditor(false);
            if (document) {
                onSelect?.(document);
            }
            setNewDocument(undefined);
        },
        [setShowDocumentEditor, onSelect],
    );

    const onRemoveDocument = React.useCallback(
        (document?: Document) => {
            document && onDelete?.(document);
            setShowDocumentEditor(false);
        },
        [onDelete],
    );

    return (
        <>
            <DocumentEditor
                visible={showDocumentEditor}
                document={newDocument}
                mimeType={documentMimeType}
                onClose={closeDocumentEditor}
                {...(onSelect ? { onSave: closeDocumentEditor } : {})}
                {...(onDelete ? { onRemove: onRemoveDocument } : {})}
            />
            <ListGroup
                testID={testID}
                style={style}
                items={
                    documents?.map((document) => ({
                        value: document.id || document.documentUrl,
                        ...(document.description
                            ? {
                                  title: document.title,
                                  description: document.description,
                              }
                            : {
                                  description: document.title,
                              }),
                        testID: document.id,
                        icon: document.icon || "file",
                        labels: document.labels,
                        ...(onDelete ? { onDelete: () => onDelete(document) } : {}),
                        onPress: () => {
                            setDocumentMimeType(document.documentMimeType);
                            setNewDocument(document);
                            setShowDocumentEditor(true);
                        },
                    })) || []
                }
            />
        </>
    );
};

export default DocumentsList;
